import axios from 'axios';
let apiUrl = "https://dazia.touhaodazi.cn/";//盲盒交流Q群：825133442 此版本不支持商用
let apiRequest = "admin";

export default {
	install: (Vue, options) => {
		Vue.prototype.apiUrl = apiUrl,
		Vue.prototype.apiRequest = apiRequest,
		Vue.prototype.host = apiUrl + apiRequest,
		Vue.prototype.ajax = function(option) {
			var that = this;
			if (typeof(option.load) == 'object') {
				option.load.load = true;
			} //加载效果

			if (option.changeUrl && option.data) { //在某种情况下需要修改url，比如翻页！
				that.$router.replace({
					query: option.data
				}).catch(err => {
					err
				});
			}

			return axios({
				method: option.method || 'get',
				url: option.url || '/',
				baseURL: option.base_url || that.host,
				data: option.method != 'post' ? {} : (option.data || {}),
				params: option.method != 'post' ? (option.data || {}) : {},
				headers: option.header || {
					'authorization': that.getToken(),
				},
				responseType: option.dataType || 'json', // 默认json
			}).then(function(res) {
				if (res.data.code == 1) {
					option.success && option.success(res.data);
				} else if (res.data.code == 401) {
					that.$message.error("您的登录好像过期了！");
					that.removeUserInfo();
					that.$router.push({path: '/login/'});
				} else {
					if (option.error) {
						option.error(res.data);
					} else {
						that.$message.error(res.data.msg);
					}
				}
				option.done && option.done(res);
				if (typeof(option.load) == 'object') {
					option.load.load = false;
				}
			}).catch(function(err) {
				that.$message.error("服务器网络异常！");
				option.done && option.done(err);
				if (typeof(option.load) == 'object') {
					option.load.load = false;
				}
			});
		},
		Vue.prototype.timeFomat = function(time, fmt = 'yyyy-MM-dd hh:mm:ss') {
			function isNumber(val) {
				var regPos = /^\d+(\.\d+)?$/; //非负浮点数
				var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
				if (regPos.test(val) || regNeg.test(val)) {
					return true;
				} else {
					return false;
				}
			}
			if (!isNumber(time)) {
				return time;
			}

			if (time.toString().length === 10) {
				time *= 1000;
			}
			let D = new Date(time);
			let o = {
				"M+": D.getMonth() + 1, //月份
				"d+": D.getDate(), //日
				"h+": D.getHours(), //小时
				"m+": D.getMinutes(), //分
				"s+": D.getSeconds(), //秒
				"q+": Math.floor((D.getMonth() + 3) / 3), //季度
				"S": D.getMilliseconds() //毫秒
			};
			fmt = fmt.replace(/\-/g, "/");
			if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (D.getFullYear() + "").substr(4 - RegExp.$1.length));
			for (let k in o)
				if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((
					"00" + o[k]).substr(("" + o[k]).length)));
			return fmt;
		},
		Vue.prototype.adaptParams = function(str) { //参数转换
			var data = {};
			var arr = str.split('&');
			var temp = null;
			for (var i = 0; i < arr.length; i++) {
				temp = arr[i].split('=');
				data[temp[0]] = temp[1];
			}
			return data;
		},
		Vue.prototype.isLogin = function(str) {
			if (localStorage.getItem('userInfo')) {
				return true;
			} else {
				return false;
			}
		},
		
		Vue.prototype.getToken = function(data) {
			if(this.isLogin()){
				return this.getUserInfo().token;
			}else{
				return "";
			}
		},
		Vue.prototype.getUserInfo = function(str) {
			var userInfo = localStorage.getItem('userInfo');
			if (userInfo) {
				return JSON.parse(userInfo);
			} else {
				return {};
			}
		},
		Vue.prototype.setUserInfo = function(data) {
			localStorage.setItem('userInfo',JSON.stringify(data));
		},
		Vue.prototype.removeUserInfo = function(data) {
			localStorage.removeItem('userInfo');
		}





	}
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 